import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {
  getMainInvoicesAsync,
  getDetailsInvoicesAsync,
  getInvoiceDataBySectionSubscriberNoAsync,
  getCallsMainAsync,
  getCallsListAsync,
  getFullMainAsync,
  getHistoryPdfListAsync,
  getAllInvoicesAsync,
  getCreditDataAsync,
  getCallsLogAuthAsync,
  getCallsLogAuthCheckLoginAsync,
  getPdfLogAuthAsync,
  getPdfAuthCheckLoginAsync,
  getAllProductsAsync,
  checkInvoicePermissionAsync
 } from './PersonalAreaInvoicesAsyncThunk';
 import helper from '../../../utilities/helper';
 import _ from 'lodash';
 import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { IdentificationActionEnum } from './Constant';
import { getSessionStorage , isMonthWithinThreeMonths} from './helper/helper';


const initialState = {
  epiData: {
    updateMailingLink: ''
  },
  page: '',
  identificationPopUp:{
    loginParam: {},
    showPopup: false,
    doAccessibilityLayer: 0,
    actionAfterLogin: null,
    form: {},
    error: '',
  },
  banList: [],
  selectedBan: {},
  invoicesInfo: {},
  detailsInvoices: {},
  refoundDetails: {},
  // arrayTypeTal: [],
  detailsProducts:[],
  isAdditionalMonths: false,
  // listTypeProduct:[],
  guidId: '',
  systemSourcePDF: '',
  isEnergy: false,
  historyPdfList: '',
  titlePopUp: '',
  detailsPopUp:'',
  // indexMonth:'',
  callsDetailsPage: {
    page: '',
    previousPage: '',
    loginParam: {},
    loginError: '',
    subscribers: [],
    selectedSubscriber: {},
    callsDetails: [],
    showPopup: false,
    popupType: '',
    sorting: {
      showSortingPopup: false,
      type: '',
      selectedSort: {
        sortName: '',
        sortType: '',
      },
      sortingData: {
        date: '', //desc/asc/''
        operator: '', //desc/asc/''
        duration:  '', //desc/asc/''
        subscriberNumber:  '', //desc/asc/''
        price:  '', //desc/asc/''
      }
    },
  },
  isShowPopUp:'',
  annualInvoiceConsolidation:{
    showPopup: false,
    pdfBase64: '',
    consolidationPdfYears:{}
  },
  allProductsInvoice:[],
  remark:null,
  cycleDate:'',
  selctedMonth:{},
  personalDetails:{
    contractNumber: '',
    address: ''
  },
  checkInvoicePermissionResult: {}
};

const personalAreaInvoicesSlice = createSlice({
  name: 'personalAreaInvoicesPage',
  initialState: initialState,
  reducers: {
    resetPage: (state) => initialState,
    initPage: {
      reducer: (state, action) => {
        state.epiData = action.payload.epiData;
        state.guidId = action.payload.guidId;
        state.page = action.payload.page;
      },
      prepare(action) {
        const payload = {};
        let guidId = helper.getUrlParameter('id');
        if(guidId){
          if(guidId.indexOf('#') !== -1){
            guidId = guidId.split('#')[0];
          }
        }
        else{
          const sessionData = getSessionStorage();
          guidId = sessionData && sessionData.id;
        }

        const epiData = {
          blockId: action.epiData.contentLink.id,
          updateMailingLink: buildUrl(action.epiData.updateMailingPageUrl.value),
          isDisplayFullAuthorizationHeader : action.epiData.isDisplayFullAuthorizationHeader.value
        }

        payload.epiData = epiData;
        payload.guidId = guidId;
        return { payload: payload };
      },
    },
    goToPage: (state, action) => {
      if(action.payload.indexOf('_') !== -1){
        state.page = action.payload.split('_')[0];
        state.callsDetailsPage.previousPage = state.callsDetailsPage.page;
        state.callsDetailsPage.page = action.payload.split('_')[1];
      }
      else{
        state.callsDetailsPage.previousPage = '';
        state.page = action.payload;
      }
    },
    resetPageCallsDetails: (state, action) => {
      state.callsDetailsPage.page = '';
      state.callsDetailsPage.previousPage = '';
    },
    resetLoginErrorCallDetails: (state) => {
      state.callsDetailsPage.loginError = '';
    },
    setCallDetailsSelectedSubscriber: (state, action) => {
      state.callsDetailsPage.selectedSubscriber = action.payload.listCallSubSection[0].listCallLinks[0];
    },
    selectedCallType: (state, action) => {
      state.callsDetailsPage.callsDetails.map(item => {
        if(item.type === action.payload){
          item.selected = true;
          item.calls = _.orderBy(item.calls, 'date', 'asc');
        }
        else{
          item.selected = false;
        }
      })
    },
    setShowSortingPopup: (state, action) => {
      state.callsDetailsPage.sorting.showSortingPopup = action.payload.isOpen;
      if(action.payload.type){
        state.callsDetailsPage.sorting.type = action.payload.type;
      }
    },
    saveCallsSorting: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state.callsDetailsPage.sorting.sortingData[key] = action.payload[key];
        if(action.payload[key]){
          state.callsDetailsPage.sorting.selectedSort = { sortName: key, sortType: action.payload[key],}
        }
      });
      const selectedSort = state.callsDetailsPage.sorting.selectedSort;
      const item = state.callsDetailsPage.callsDetails?.find(item => item.selected == true);
      if (item) {
        item.calls = _.orderBy(item.calls, selectedSort.sortName, selectedSort.sortType);
      }
    },
    resetSortingData: (state, action) => {
      state.callsDetailsPage.sorting.sortingData = initialState.callsDetailsPage.sorting.sortingData;
      state.callsDetailsPage.sorting.selectedSort = { sortName: '', sortType: '',}
      const item = state.callsDetailsPage.callsDetails?.find(item => item.selected == true);
      if (item) {
        item.calls = _.orderBy(item.calls, 'date', 'asc');
      }
    },
    reportDWH: (state, action) => { },
    setAdditionalMonths: (state, action) => {
      state.isAdditionalMonths = action.payload
    },
    setGuidId:  (state, action) => {
      state.guidId = action.payload
    },
    setSystemSourcePDF: (state, action) => {
      state.systemSourcePDF = action.payload;
    },
    setSelectedBan: (state, action) => {
      state.selectedBan = action.payload;
    },
    setInfoPopUP: (state, action) => {
      state.titlePopUp = action.payload.title;
      state.detailsPopUp = action.payload.data;
      state.typePopUp = action.payload.type ?? '';
    },
    setCallsDetailsPopUp: (state, action) => {
      state.callsDetailsPage.showPopup = action.payload.isDisplay;
      if(action.payload.popupType){
        state.callsDetailsPage.popupType = action.payload.popupType;
      }
    },
    closeIdentificationPopUp: (state, action) => {
      state.identificationPopUp.showPopup = false;
    },
    setIsShowPopUp: (state, action) => {
      state.isShowPopUp = action.payload;
    },
    setDetailsProducts: (state, action) => {
      state.detailsProducts= [];
    },
    setShowAnnualInvoicePopup: (state, action) => {
      state.annualInvoiceConsolidation.showPopup = action.payload;
    },
    setRemark: (state, action) => {
      state.remark = action.payload;
    },
    setCycleDate: (state, action) => {
      state.cycleDate = action.payload;
    },
    setSelctedMonth: (state, action) => {
      state.selctedMonth = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    }
  },
  extraReducers: {
    [getAllInvoicesAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.banList = action.payload.dataInvoices;
      if(state.banList.length > 0){
        if(state.guidId){
          const selectedBan = state.banList.find(ban => ban.guidId === state.guidId);
          state.selectedBan = selectedBan ?? state.banList[0];
        }else{
          state.selectedBan = state.banList[0];
        }
        state.selectedBan.hasCellular = state.selectedBan.listServices?.some(service => service === 'CELLULAR');
      }
      if(action.payload.customerPerBan){
        state.selectedBan.details = action.payload.customerPerBan;
        state.selectedBan.details.periodDate = state.banList.find(ban => ban.guidId === state.guidId)?.fullCycleDate;
      }
      else{
        state.selectedBan.details = {};
      }
    },
    [getFullMainAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      const result = action.payload;
      state.invoicesInfo = result;
      state.selectedBan.ban = result.history?.find(ban => ban.guidId === state.guidId)?.ban;
      // state.arrayTypeTal = result.arrayTypeTal;
      // state.listTypeProduct = result.listTypeProduct;
      state.refoundDetails = {};
      state.selctedMonth = result.history?.find(x => x.guidId === state.guidId);
      state.cycleDate = state.selctedMonth?.cycleDate;
      state.systemSourcePDF = result.systemSourcePDF;
      // state.indexMonth = result.history.findIndex(x => x.guidId === state.guidId);
    },
    [getCallsMainAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.callsDetailsPage.subscribers = action.payload.listCallSections;
    },
    [getAllProductsAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      const product = action.payload;
      state.detailsProducts = [product];
      const cellular = product.allDetailsCliProduct?.find(item => item.detailsType === 'CELLULAR' );
      const energy = product.allDetailsCliProduct?.find(item => item.detailsType === 'ENERGY');
      //state.selectedBan.hasCellular = cellular ? true : false;
      if(cellular){
        const cycleDate = state.selectedBan?.cycle_date;
        state.callsDetailsPage.subscribers = cellular.allDalDetailsCli?.map(item => ({
          userPhone: item.userPhone,
          isCallLogsExists: item.isCalllogsExists,
        //   isDisplayCallDetails: item.isCalllogsExists ? item.isCalllogsExists  :   isMonthWithinThreeMonths(cycleDate),
        }));
      }
      state.isEnergy = energy ? true : false;
      state.personalDetails.contractNumber = energy?.allDalDetailsCli[0].subTitleDescription ?? '';
      state.personalDetails.address = energy?.allDalDetailsCli[0].address ?? '';
      state.allProductsInvoice = action.payload;
    },
    [getCallsListAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.callsDetailsPage.callsDetails = callDetailsFormat(action.payload);
    },
    [getHistoryPdfListAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      const result = action.payload;
      const pdfsWithType = result.pdfs?.map((item) => ({
        ...item,
        tax: IdentificationActionEnum.DISPLAY_TAX_INVOICE,
        accessible: IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE
      }));
      state.historyPdfList = pdfsWithType;
    },
    [getCreditDataAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.refoundDetails = getCreditData(action.payload);
    },
    [getCallsLogAuthAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.callsDetailsPage.subscriberNo = action.payload.subscriberNo;
      state.callsDetailsPage.loginParam = action.payload.logResponse.loginParam;
      if(!action.payload.logResponse.loginParam.isLoginPageView && action.payload.logResponse.isCallLogExists){
        state.callsDetailsPage.callsDetails = callDetailsFormat(action.payload.logResponse.dalCallList);
      }
    },
    [getCallsLogAuthCheckLoginAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.callsDetailsPage.loginError = '';
      if(!action.payload.logResponse.isLognSuccess){
        state.callsDetailsPage.loginError = 'פרטי הזיהוי שגויים';
      }
      else if(action.payload.logResponse.isCallLogExists){
        state.callsDetailsPage.callsDetails = callDetailsFormat(action.payload.logResponse.dalCallList);
      }
    },
    [getPdfLogAuthAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.identificationPopUp.error = '';
      state.identificationPopUp.doAccessibilityLayer = action.payload.doAccessibilityLayer;
      state.identificationPopUp.isConsolidationPdf = action.payload.isConsolidationPdf;
      state.identificationPopUp.invoiceId = action.payload.invoiceId;
      state.identificationPopUp.systemSourcePDF = action.payload.systemSourcePDF;
      if(action.payload.pdfResponse.loginParam.isLoginPageView){
        state.identificationPopUp.loginParam = action.payload.pdfResponse.loginParam;
        state.identificationPopUp.actionAfterLogin = action.payload.doAccessibilityLayer ? IdentificationActionEnum.DISPLAY_ACCESSIBLE_INVOICE : IdentificationActionEnum.DISPLAY_TAX_INVOICE;
        state.identificationPopUp.showPopup = true;
      }else{
        if(action.payload.isConsolidationPdf){
          state.annualInvoiceConsolidation.showPopup = true;
          state.annualInvoiceConsolidation.pdfBase64 = action.payload.pdfResponse?.base64;
          state.annualInvoiceConsolidation.consolidationPdfYears = action.payload.pdfResponse?.consolidationPdfYears;
        }
      }
    },
    [getPdfAuthCheckLoginAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      if(!action.payload.logResponse.isLognSuccess){
        state.identificationPopUp.error = 'פרטי הזיהוי שגויים';
      }
      else{
        state.identificationPopUp.showPopup = false;
        if(action.payload.isConsolidationPdf){
          state.annualInvoiceConsolidation.showPopup = true;
          state.annualInvoiceConsolidation.pdfBase64 = action.payload.logResponse?.base64;
          state.annualInvoiceConsolidation.consolidationPdfYears = action.payload.logResponse?.consolidationPdfYears;
        }
      }
    },
    [checkInvoicePermissionAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.checkInvoicePermissionResult = action.payload;
    }
  },
});

export const {
  reportDWH,
  goToPage,
  resetPageCallsDetails,
  resetLoginErrorCallDetails,
  saveCallsSorting,
  resetSortingData,
  setCallDetailsSelectedSubscriber,
  setShowSortingPopup,
  initPage,
  setAdditionalMonths,
  setGuidId,
  setSystemSourcePDF,
  setSelectedBan,
  setInfoPopUP,
  // setIndexMonths,
  setCallsDetailsPopUp,
  closeIdentificationPopUp,
  setIsShowPopUp,
  selectedCallType,
  setDetailsProducts,
  setShowAnnualInvoicePopup,
  setRemark,
  setCycleDate,
  setSelctedMonth,
  setPage
} = personalAreaInvoicesSlice.actions;


export default personalAreaInvoicesSlice.reducer;


function callDetailsFormat(callDetails){
  const callsList = callDetails?.dalCallListPage?.map((callType, index) => {
    const title = callType.title;
    const type = callType.index;
    const columns = callType.listCallListColumn?.map((call, index) => {
      if(callType.index.indexOf('ROAMING') !== -1){//חו"ל
        return {
          index: index,
          dateText: call.listColumn[0]?.columnVal,
          date: parseDate(call.listColumn[0]?.columnVal, call.listColumn[1]?.columnVal),
          year: call.listColumn[1]?.columnVal,
          subscriberNumber: call.listColumn[3]?.columnVal,
          durationText: call.listColumn[4]?.columnVal,
          duration: getTotalSeconds(call.listColumn[4]?.columnVal),
          operator: call.listColumn[5]?.columnVal,//מפעיל
          source: call.listColumn[6]?.columnVal, //מקור
          pricePerMinute: call.listColumn[8]?.columnVal != "" ? call.listColumn[8].columnVal : "0.00",
          price: call.listColumn[9]?.columnVal,
        }
      } else {
        return {
          index: index,
          dateText: call.listColumn[0]?.columnVal,
          date: parseDate(call.listColumn[0]?.columnVal, call.listColumn[1].columnVal),
          year: call.listColumn[1]?.columnVal,
          subscriberNumber: call.listColumn[3]?.columnVal,
          operator: call.listColumn[4]?.columnVal,//מפעיל
          durationText: call.listColumn[5]?.columnVal,
          duration: getTotalSeconds(call.listColumn[5]?.columnVal),
          price: call.listColumn[9]?.columnVal,
        }
      }
    });

    return{
      title: title,
      type: type,
      calls: columns
    }
  });
  if(callsList.length == 1){
    callsList[0].selected = true;
  }
  return callsList;
}

const getTotalSeconds = (duration) => {
  const [minutes, seconds] = duration.split(":").map(Number);
  return minutes * 60 + seconds;
};

const parseDate = (dateStr, year) => {
  const [dayMonth, time] = dateStr.split(' ');
  const [day, month] = dayMonth.split('/').map(Number);
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
};

const getCreditData = (creditData) => {
  const refoundDetails = {
    footerText: '',
    date: '',
    fullName: '',
    invoiceNumber: '',
    refoundText: '',
    refoundPrice: {
      priceBeforeTax: [],
      tax: {text: '', price: 0},
      priceAfterTax: 0,

    }
  };
  creditData.listCreditComment.forEach((item) => {
    if(item.isCellcom){
      refoundDetails.footerText = item.text1;
    }
    else if(item.isDate){
      refoundDetails.date = item.text2;
    }
    else if(item.isName){
      refoundDetails.fullName = item.text1?.replace("לכבוד:", "").trim();
    }
    else if(item.isInvoiceNo){
      refoundDetails.invoiceNumber = item.text2;
    }
    else if(item.isRefund){
      refoundDetails.refoundText = item.text1;
    }
  });
  creditData?.listCreditTable.forEach((item) => {
    item?.listTableFooter?.forEach((item) => {
    if(!item.isSumFooter && !item.isTax && !item.isFooter){
      refoundDetails.refoundPrice.priceBeforeTax.push({
        text:  item.column1,
        price: '-₪' + item.amountData.amount + '.' + item.amountData.amountAgorot
      });
    }
    if(!item.isSumFooter && item.isTax){
      refoundDetails.refoundPrice.tax = {
        text:  item.column1,
        price: '-₪' + item.amountData.amount + '.' + item.amountData.amountAgorot
      };
    }
    if(item.isFooter){
      refoundDetails.refoundPrice.priceAfterTax = '-₪' + item.amountData.amount + '.' + item.amountData.amountAgorot;
    }
  });
});

  return refoundDetails;
}

